import { useEffect, useState } from 'react';
import unsplash from '../../api/unsplash';
import { getTokenFromLocalStorage } from '../../utils/localStorageHelpers';
import {
    DataGridPro,
    GridToolbarContainer,
    GridToolbarQuickFilter,
    itIT,
} from '@mui/x-data-grid-pro';
import {
    IconButton,
    Grid,
    Dialog,
    TextField,
    Button,
    Skeleton,
} from '@mui/material';
import {
    Download,
    Close,
    Check,
    VpnKey,
    Visibility,
    DeleteOutline,
} from '@mui/icons-material';
import GlobalSnackbar from '../Snackbar';
import moment from 'moment';
import { CustomFooterPersonalized } from '../../utils/CustomFooterPersonalized';
import { AllegatiList } from './AllegatiList';

const ext = {
    doc: 'application/msword',
    dot: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    dotx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
    docm: 'application/vnd.ms-word.document.macroEnabled.12',
    dotm: 'application/vnd.ms-word.template.macroEnabled.12',
    xls: 'application/vnd.ms-excel',
    xlt: 'application/vnd.ms-excel',
    xla: 'application/vnd.ms-excel',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    xltx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
    xlsm: 'application/vnd.ms-excel.sheet.macroEnabled.12',
    xltm: 'application/vnd.ms-excel.template.macroEnabled.12',
    xlam: 'application/vnd.ms-excel.addin.macroEnabled.12',
    xlsb: 'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
    ppt: 'application/vnd.ms-powerpoint',
    pot: 'application/vnd.ms-powerpoint',
    pps: 'application/vnd.ms-powerpoint',
    ppa: 'application/vnd.ms-powerpoint',
    pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    potx: 'application/vnd.openxmlformats-officedocument.presentationml.template',
    ppsx: 'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
    ppam: 'application/vnd.ms-powerpoint.addin.macroEnabled.12',
    pptm: 'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
    potm: 'application/vnd.ms-powerpoint.template.macroEnabled.12',
    ppsm: 'application/vnd.ms-powerpoint.slideshow.macroEnabled.12',
    mdb: 'application/vnd.ms-access',
    png: 'application/png',
    pdf: 'application/pdf',
};

const AllegatiLavoratore = (props) => {
    const [allegati, setAllegati] = useState([]);

    const [openSnack, setOpenSnack] = useState(false);
    const [snack, setSnack] = useState({
        severity: 'success',
        messaggio: 'Salvataggio Effettuato correttamente',
        open: false,
    });

    const handleCloseSnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnack(false);
    };
    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <Grid
                    container
                    direction="row"
                    alignItems="center"
                    justifyContent="flex-start"
                    padding={2}
                >
                    <GridToolbarQuickFilter placeholder="Cerca..." />
                </Grid>
            </GridToolbarContainer>
        );
    }
    const columnsAllegati = [
        {
            filterable: false,
            field: 'Actions',
            headerName: 'Azioni',
            hide: false,
            width: '100',
            renderCell: (
                params //mi aiuta a mettere il valore
            ) => (
                <ModalNewDoc
                    el={params.row}
                    reloadAll={reloadAll}
                    download={() =>
                        downloadFile(
                            params.row.ID,
                            params.row.Estensione,
                            params.row.Descrizione,
                            'download'
                        )
                    }
                    downloadCrypt={downloadFileCrypt}
                    isMedico={props.isMedico}
                />
            ),
        },
        /* {
      filterable: false,
      field: "Criptato",
      headerName: "",
      width: "20",
      renderCell: (params) =>
        params.row.Criptato === 1 ? (
          <VpnKey style={{ color: "#2265B1" }} />
        ) : (
          ""
        ),
    }, */
        {
            filterable: false,
            field: 'DataVisualizzazione',
            headerName: 'Data Visualizzazione',
            width: '150',
            renderCell: (params) =>
                params.row.DataVisualizzazione
                    ? moment(params.row.DataVisualizzazione).format(
                          'DD/MM/YYYY'
                      )
                    : '',
        },

        {
            field: 'Descrizione',
            headerName: 'Descrizione',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
            renderCell: (params) =>
                params.row.Criptato === 1
                    ? params.row.Descrizione.replace(
                          params.row.Estensione,
                          params.row.EstensioneOriginale
                      )
                    : params.row.Descrizione,
        },
    ];

    const downloadFile = async (id, estensione, descrizione, operazione) => {
        console.log('innn');
        try {
            const response = await unsplash.post(
                'ftp',
                {
                    file: id + estensione,
                    nomeOriginale: descrizione.includes(estensione)
                        ? descrizione
                        : descrizione + estensione,
                    operazione: 'download',
                },
                {
                    headers: {
                        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
                    },
                    responseType: 'blob',
                }
            );
            const url = window.URL.createObjectURL(
                new Blob([response.data], {
                    type: ext[estensione.replace('.', '')],
                })
            );
            const link = document.createElement('a');
            link.href = url;
            if (operazione === 'download') {
                link.setAttribute(
                    'download',
                    descrizione.includes(estensione)
                        ? descrizione
                        : descrizione + estensione
                );
                document.body.appendChild(link);
                link.click();
            }
            setSnack({
                severity: 'success',
                messaggio: 'File scaricato con successo',
            });
            setOpenSnack(true);
        } catch (error) {
            setSnack({
                severity: 'error',
                messaggio: 'Errore durante il dowload del file',
            });
            setOpenSnack(true);
        }
    };

    const downloadFileCrypt = async (
        id,
        estensione,
        descrizione,
        operazione,
        criptato,
        estensioneOriginale,
        psw,
        lavoratore
    ) => {
        //let psw;

        /* if (criptato === 1) {
      psw = window.prompt(
        "Inserisci la tua password per scaricare questo documento"
      );
    } */
        try {
            const response = await unsplash.post(
                'ftp',
                {
                    file: id + estensione,
                    nomeOriginale: descrizione.includes(estensione)
                        ? descrizione
                        : descrizione + estensione,
                    operazione: 'downloadCrypt',
                    lavoratore:
                        lavoratore ?? sessionStorage.getItem('lavoratore'),
                    estensioneOriginale: estensioneOriginale,
                    password: psw,
                },
                {
                    headers: {
                        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
                    },
                    responseType: 'blob',
                }
            );
            const url = window.URL.createObjectURL(
                new Blob([response.data], {
                    type: ext[estensione.replace('.', '')],
                })
            );
            const link = document.createElement('a');
            link.href = url;
            if (operazione === 'download') {
                link.setAttribute(
                    'download',
                    descrizione.replace(estensione, estensioneOriginale)
                );
                document.body.appendChild(link);
                link.click();
            }
            setSnack({
                severity: 'success',
                messaggio: 'File scaricato con successo',
            });
            setOpenSnack(true);
        } catch (error) {
            setSnack({
                severity: 'error',
                messaggio: 'Errore durante il dowload del file',
            });
            setOpenSnack(true);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                let respData = await unsplash.post(
                    'portaleLavoratori/getAll',
                    {
                        lavoratore: sessionStorage.getItem('lavoratore'),
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${getTokenFromLocalStorage()}`,
                        },
                    }
                );

                setAllegati(respData.data.allegati);
            } catch {
                setAllegati([]);
            }
        };
        fetchData();
    }, []);

    const reloadAll = async () => {
        let respData = await unsplash.post(
            'portaleLavoratori/getAll',
            {
                lavoratore: sessionStorage.getItem('lavoratore'),
            },
            {
                headers: {
                    Authorization: `Bearer ${getTokenFromLocalStorage()}`,
                },
            }
        );

        setAllegati(respData.data.allegati);
    };

    const listAction = async (params) => {
        document.getElementById('allegatoList').click();
        console.log(params);
    };

    return (
        <>
            <GlobalSnackbar
                severity={snack.severity}
                messaggio={snack.messaggio}
                openSnack={openSnack}
                handleCloseSnack={handleCloseSnack}
            />

            <div className="hidden lg:block h-[75vh] md:h-[80vh] w-full bg-transparent">
                <DataGridPro
                    components={{
                        Toolbar: CustomToolbar,
                        Footer: CustomFooterPersonalized,
                    }}
                    sx={{ fontSize: 12, backgroundColor: 'white' }}
                    localeText={
                        itIT.components.MuiDataGrid.defaultProps.localeText
                    }
                    rows={allegati}
                    columns={columnsAllegati}
                    getRowId={(row) => row.ID}
                    pageSize={100}
                    disableSelectionOnClick
                />
            </div>
            <div className="lg:hidden block">
                {allegati?.length > 0 ? (
                    <>
                        <AllegatiList
                            data={allegati.map((al) => {
                                return {
                                    ...al,
                                    DataVisualizzazione: al.DataVisualizzazione
                                        ? moment(al.DataVisualizzazione).format(
                                              'DD/MM/YYYY'
                                          )
                                        : '',
                                };
                            })}
                            rightCard={[
                                { title: true, prop: 'Descrizione' },
                                {
                                    prop: 'DataVisualizzazione',
                                    icon: <Visibility fontSize="medium" />,
                                },
                            ]}
                            actions={listAction}
                            component={
                                <ModalNewDoc
                                    reloadAll={reloadAll}
                                    downloadCrypt={downloadFileCrypt}
                                    download={downloadFile}
                                    isMedico={props.isMedico}
                                />
                            }
                        />
                    </>
                ) : (
                    <div className="flex flex-wrap gap-2">
                        <div className="flex w-full gap-2">
                            <Skeleton
                                variant="rounded"
                                width={70}
                                height={70}
                            />
                            <Skeleton
                                variant="rounded"
                                width="90%"
                                height={70}
                            />
                        </div>
                        <div className="flex w-full gap-2">
                            <Skeleton
                                variant="rounded"
                                width={70}
                                height={70}
                            />
                            <Skeleton
                                variant="rounded"
                                width="90%"
                                height={70}
                            />
                        </div>
                        <div className="flex w-full gap-2">
                            <Skeleton
                                variant="rounded"
                                width={70}
                                height={70}
                            />
                            <Skeleton
                                variant="rounded"
                                width="90%"
                                height={70}
                            />
                        </div>
                        <div className="flex w-full gap-2">
                            <Skeleton
                                variant="rounded"
                                width={70}
                                height={70}
                            />
                            <Skeleton
                                variant="rounded"
                                width="90%"
                                height={70}
                            />
                        </div>
                        <div className="flex w-full gap-2">
                            <Skeleton
                                variant="rounded"
                                width={70}
                                height={70}
                            />
                            <Skeleton
                                variant="rounded"
                                width="90%"
                                height={70}
                            />
                        </div>
                        <div className="flex w-full gap-2">
                            <Skeleton
                                variant="rounded"
                                width={70}
                                height={70}
                            />
                            <Skeleton
                                variant="rounded"
                                width="90%"
                                height={70}
                            />
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default AllegatiLavoratore;

export const ModalNewDoc = (props) => {
    const [open, setOpen] = useState(false);
    const [password, setPassword] = useState('');
    const [openMessage, setOpenMessage] = useState(false);
    const [action, setAction] = useState('download'); // 'download' | 'preview'
    const [pendingAction, setPendingAction] = useState(null);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [previewMime, setPreviewMime] = useState(null);
    const [previewName, setPreviewName] = useState(null);
    const [previewError, setPreviewError] = useState(null);
    const [reloadAfterPreviewClose, setReloadAfterPreviewClose] =
        useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const _makeFilename = () => {
        const est = props.el?.Estensione ?? '';
        const base = props.el?.Descrizione ?? 'documento';
        return base.includes(est) ? base : base + est;
    };

    const _makeFilenameCrypt = () => {
        const est = props.el?.Estensione ?? '';
        const base = props.el?.Descrizione ?? 'documento';
        const originalExt = props.el?.EstensioneOriginale ?? est;
        return base.replace(est, originalExt);
    };

    const _canPreview = () => {
        // Anteprima supportata solo per PDF e immagini.
        const extWithDot =
            props.el?.Criptato === 1
                ? props.el?.EstensioneOriginale
                : props.el?.Estensione;
        if (!extWithDot) return false;
        const k = String(extWithDot).replace('.', '').toLowerCase();
        return (
            k === 'pdf' ||
            k === 'png' ||
            k === 'jpg' ||
            k === 'jpeg' ||
            k === 'gif' ||
            k === 'webp'
        );
    };

    const _canDeleteAsMedico = () => {
        if (!props.isMedico) return false;
        const myMedicoId = sessionStorage.getItem('Medico');
        if (!myMedicoId) return false;
        if (!props.el?.Medico) return false;
        return String(props.el.Medico) === String(myMedicoId);
    };

    const _deleteDoc = async () => {
        const ok = window.confirm('Vuoi eliminare definitivamente questo documento?');
        if (!ok) return;
        try {
            await unsplash.post(
                'ftp',
                {
                    file: props.el.ID + props.el.Estensione,
                    operazione: 'delete',
                },
                {
                    headers: {
                        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
                    },
                }
            );
            if (typeof props.reloadAll === 'function') {
                props.reloadAll();
            }
        } catch (e) {
            console.error('Errore eliminazione documento:', e);
            window.alert('Errore durante eliminazione documento');
        }
    };

    const _getMimeFromExt = (extWithDot) => {
        const k = String(extWithDot || '').replace('.', '').toLowerCase();
        return ext[k] || 'application/octet-stream';
    };

    const _closePreview = () => {
        setPreviewOpen(false);
        setPreviewError(null);
        setPreviewName(null);
        setPreviewMime(null);
        if (previewUrl) {
            try {
                window.URL.revokeObjectURL(previewUrl);
            } catch {
                // ignore
            }
        }
        setPreviewUrl(null);
        if (reloadAfterPreviewClose && typeof props.reloadAll === 'function') {
            props.reloadAll();
        }
        setReloadAfterPreviewClose(false);
    };

    const _openPreviewFromBlob = (blob, filename, reloadOnClose = false) => {
        const url = window.URL.createObjectURL(blob);
        setPreviewUrl(url);
        setPreviewMime(blob.type || null);
        setPreviewName(filename || null);
        setReloadAfterPreviewClose(reloadOnClose);
        setPreviewOpen(true);
    };

    const _fetchBlob = async ({ passwordOverride } = {}) => {
        const isCrypt = props.el?.Criptato === 1;
        const est = props.el?.Estensione ?? '';
        const filename = isCrypt ? _makeFilenameCrypt() : _makeFilename();

        const body = isCrypt
            ? {
                  file: props.el.ID + est,
                  nomeOriginale: _makeFilename(),
                  operazione: 'downloadCrypt',
                  estensioneOriginale: props.el.EstensioneOriginale,
                  password: passwordOverride || null,
                  lavoratore:
                      props.el.Lavoratore ??
                      sessionStorage.getItem('lavoratore'),
              }
            : {
                  file: props.el.ID + est,
                  nomeOriginale: filename,
                  operazione: 'download',
              };

        const mime = isCrypt
            ? _getMimeFromExt(props.el?.EstensioneOriginale)
            : _getMimeFromExt(est);

        const response = await unsplash.post('ftp', body, {
            headers: {
                Authorization: `Bearer ${getTokenFromLocalStorage()}`,
            },
            responseType: 'blob',
        });

        return {
            filename,
            blob: new Blob([response.data], { type: mime }),
        };
    };

    const confermaEvisuallizza = async () => {
        // DataVisualizzazione e' per il lavoratore. Se e' il medico a scaricare/vedere, non aggiornare.
        if (!props.isMedico) {
            await unsplash.put(
                'allegati/primaVisualizzazione',
                {
                    id: props.el.IDAllegatiProcedure
                        ? props.el.IDAllegatiProcedure
                        : props.el.ID,
                    type: props.el.IDAllegatiProcedure ? 'Procedura' : '',
                    idAllegatoProcedure: props.el.IDAllegatiProcedure,
                },
                {
                    headers: {
                        Authorization: `Bearer ${getTokenFromLocalStorage()}`,
                    },
                }
            );
        }

        if (props.el.Criptato === 1) {
            if (props.isMedico) {
                if (action === 'preview') {
                    try {
                        setPreviewError(null);
                        const { blob, filename } = await _fetchBlob();
                        _openPreviewFromBlob(blob, filename);
                    } catch {
                        setPreviewError(
                            'Anteprima non disponibile: errore durante il download del file.'
                        );
                    } finally {
                        props.reloadAll();
                        setOpen(false);
                    }
                } else {
                    await props.downloadCrypt(
                        props.el.ID,
                        props.el.Estensione,
                        props.el.Descrizione,
                        'download',
                        props.el.Criptato,
                        props.el.EstensioneOriginale,
                        null,
                        props.el.Lavoratore
                    );
                    props.reloadAll();
                    setOpen(false);
                }
            } else {
                setPendingAction(action);
                setOpenMessage(true);
            }
        } else {
            if (action === 'preview') {
                try {
                    setPreviewError(null);
                    const { blob, filename } = await _fetchBlob();
                    _openPreviewFromBlob(blob, filename, true);
                } catch {
                    setPreviewError(
                        'Anteprima non disponibile: errore durante il download del file.'
                    );
                } finally {
                    setOpen(false);
                }
            } else {
                props.download();
                props.reloadAll();
                setOpen(false);
            }
        }
    };

    return (
        <>
            {(() => {
                // Keep icon alignment stable across rows: same slots for the same action types.
                const color = '#11526f';
                const iconStyle = { height: '1.6rem', width: '1.6rem', color };

                const Slot = ({ visible, label, onClick, children, disabled }) => (
                    <IconButton
                        aria-label={label}
                        onClick={onClick}
                        size="small"
                        disabled={disabled || !visible}
                        sx={{
                            p: 0.5,
                            visibility: visible ? 'visible' : 'hidden',
                            pointerEvents: visible ? 'auto' : 'none',
                        }}
                    >
                        {children}
                    </IconButton>
                );

                const showPreview = _canPreview();
                const showDeleteSlot = Boolean(props.isMedico);
                const showDelete = _canDeleteAsMedico();
                const showKey = props.el?.Criptato === 1;
                const visibleIcons =
                    1 +
                    (showPreview ? 1 : 0) +
                    (showDeleteSlot && showDelete ? 1 : 0) +
                    (showKey ? 1 : 0);

                if (visibleIcons === 1) {
                    // Only one action/icon available: make it large and centered.
                    return (
                        <div
                            style={{
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <IconButton
                                aria-label="download"
                                onClick={() => {
                                    setAction('download');
                                    setPendingAction(null);
                                    setOpenMessage(false);
                                    handleClickOpen();
                                }}
                                size="large"
                            >
                                <Download
                                    style={{
                                        height: '2.2rem',
                                        width: '2.2rem',
                                        color,
                                    }}
                                />
                            </IconButton>
                        </div>
                    );
                }

                return (
                    <div
                        style={{
                            display: 'inline-grid',
                            gridAutoFlow: 'column',
                            gridAutoColumns: '34px',
                            columnGap: '4px',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: 'fit-content',
                        }}
                    >
                        <Slot
                            visible={true}
                            label="download"
                            onClick={() => {
                                setAction('download');
                                setPendingAction(null);
                                setOpenMessage(false);
                                handleClickOpen();
                            }}
                        >
                            <Download style={iconStyle} />
                        </Slot>

                        <Slot
                            visible={showPreview}
                            label="preview"
                            onClick={() => {
                                setAction('preview');
                                setPendingAction(null);
                                setOpenMessage(false);
                                handleClickOpen();
                            }}
                        >
                            <Visibility style={iconStyle} />
                        </Slot>

                        {showDeleteSlot ? (
                            <Slot
                                visible={showDelete}
                                label="delete"
                                onClick={_deleteDoc}
                            >
                                <DeleteOutline style={iconStyle} />
                            </Slot>
                        ) : null}

                        <Slot
                            visible={true}
                            label="crypt"
                            disabled={true}
                        >
                            <VpnKey
                                style={{
                                    ...iconStyle,
                                    visibility: showKey ? 'visible' : 'hidden',
                                }}
                            />
                        </Slot>
                    </div>
                );
            })()}

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth
                maxWidth={'md'}
            >
                <div className="py-6 px-6 lg:px-8">
                    <h3 className="mb-4 text-xl font-medium text-center text-black">
                        {openMessage
                            ? 'Inserimento Password'
                            : 'Conferma Visualizzazione'}
                    </h3>
                    <button
                        onClick={() => setOpen(false)}
                        type="button"
                        className="absolute top-4 right-5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white"
                        data-modal-toggle="authentication-modal"
                    >
                        <svg
                            aria-hidden="true"
                            className="w-7 h-7"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fillRule="evenodd"
                                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                clipRule="evenodd"
                            ></path>
                        </svg>
                        <span className="sr-only">Close modal</span>
                    </button>
                    <div className="w-full">
                        {openMessage ? (
                            <>
                                <p>
                                    Inserisci la tua password per scaricare
                                    questo documento:
                                </p>
                                <Grid item xs={12}>
                                    <TextField
                                        type="password"
                                        margin="dense"
                                        name="Password"
                                        label="Password"
                                        fullWidth
                                        value={password}
                                        onChange={(e) =>
                                            setPassword(e.target.value)
                                        }
                                        variant="outlined"
                                    />
                                </Grid>
                            </>
                        ) : (
                            <p>
                                Confermi di voler visualizzare il seguente
                                documento: <b>{props.el?.Descrizione}</b>?
                            </p>
                        )}

                        <div className="flex justify-between mt-4 ">
                            <Button
                                className="ButtonMiller"
                                variant="contained"
                                startIcon={<Close />}
                                //className="bg-primary-600 text-white p-2 hover:bg-primary-100 mb-2 transition-all duration-300 ease-in-out"
                                onClick={handleClose}
                            >
                                Annulla
                            </Button>
                            <Button
                                className="ButtonMiller"
                                variant="contained"
                                startIcon={<Check />}
                                //className="bg-primary-600 text-white p-2 hover:bg-primary-100 mb-2 transition-all duration-300 ease-in-out"
                                onClick={() => {
                                    if (!openMessage) {
                                        confermaEvisuallizza();
                                    } else {
                                        if (pendingAction === 'preview') {
                                            (async () => {
                                                try {
                                                    setPreviewError(null);
                                                    const { blob, filename } =
                                                        await _fetchBlob({
                                                            passwordOverride:
                                                                password,
                                                        });
                                                    _openPreviewFromBlob(
                                                        blob,
                                                        filename,
                                                        true
                                                    );
                                                } catch {
                                                    setPreviewError(
                                                        'Anteprima non disponibile: password errata o errore durante il download.'
                                                    );
                                                }
                                            })();
                                        } else {
                                            props.downloadCrypt(
                                                props.el.ID,
                                                props.el.Estensione,
                                                props.el.Descrizione,
                                                'download',
                                                props.el.Criptato,
                                                props.el.EstensioneOriginale,
                                                password,
                                                props.el.Lavoratore
                                            );
                                        }
                                        setOpen(false);
                                        setOpenMessage(false);
                                        setPendingAction(null);
                                        setPassword('');
                                    }
                                }}
                            >
                                {openMessage
                                    ? 'Invia'
                                    : action === 'preview'
                                    ? 'Apri anteprima'
                                    : 'Conferma e scarica'}
                            </Button>
                        </div>
                    </div>
                </div>
            </Dialog>

            <Dialog
                open={previewOpen}
                onClose={_closePreview}
                aria-labelledby="preview-dialog-title"
                fullWidth
                maxWidth="md"
            >
                <div className="py-6 px-6 lg:px-8">
                    <h3
                        id="preview-dialog-title"
                        className="mb-4 text-xl font-medium text-center text-black"
                    >
                        Anteprima documento
                    </h3>

                    {previewError ? (
                        <p className="text-center text-red-700">
                            {previewError}
                        </p>
                    ) : (
                        <>
                            {previewName ? (
                                <p className="text-center text-sm text-slate-600 mb-3">
                                    {previewName}
                                </p>
                            ) : null}

                            {previewUrl &&
                            previewMime === 'application/pdf' ? (
                                <object
                                    data={previewUrl}
                                    type="application/pdf"
                                    width="100%"
                                    height="600px"
                                >
                                    Il browser non supporta la visualizzazione
                                    PDF.
                                </object>
                            ) : previewUrl &&
                              previewMime &&
                              previewMime.startsWith('image/') ? (
                                <img
                                    src={previewUrl}
                                    alt="Anteprima documento"
                                    className="w-full max-h-[600px] object-contain"
                                />
                            ) : (
                                <div className="text-center">
                                    <p className="mb-3">
                                        Anteprima non disponibile per questo
                                        tipo di file.
                                    </p>
                                    {previewUrl ? (
                                        <Button
                                            variant="outlined"
                                            onClick={() =>
                                                window.open(
                                                    previewUrl,
                                                    '_blank',
                                                    'noopener,noreferrer'
                                                )
                                            }
                                        >
                                            Apri in nuova scheda
                                        </Button>
                                    ) : null}
                                </div>
                            )}
                        </>
                    )}

                    <div className="flex justify-end mt-4">
                        <Button
                            className="ButtonMiller"
                            variant="contained"
                            onClick={_closePreview}
                        >
                            Chiudi
                        </Button>
                    </div>
                </div>
            </Dialog>
        </>
    );
};
